
import samplePlayer from './modules/sample-player.js';

$(document).ready(function(){
    var resize = function(){
        var h = window.innerHeight;
        $('.swiper-head .swiper-slide,.swiper-head').css('height',h)
    }
    samplePlayer();
    resize();
    window.onresize = function(event) {
        resize()
    }
});

var swiper2 = new Swiper('.swiper-head', {
    autoplay: 2500,
    onSlideChangeEnd: function(swiper) {
       $('.top-video__list li.active-sublink').removeClass('active-sublink').next().addClass('active-sublink');

        // var listItems = $('.top-video__list li');
        // var activeItem = listItems.find('.active-sublink');
        // var nextItem = activeItem.next() || listItems[0];
        //
        // activeItem.removeClass('active-sublink');
        // nextItem.addClass('active-sublink');
        // console.log(listItems);
     }
});
